export default {"src":"/_next/static/media/instagram-profile-image.59545b6c.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};